import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import VerticalLabelList from '../../label/VerticalLabelList';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';
import ObjectUtils from '../../../modules/ObjectUtils';

class DetailedWaterBill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.showModal(this.props.isOpen);
    }
  }

  showModal = (isOpen) => {
    this.setState({
      isOpen,
    });
  };

  sendNavigationRequest() {
    return null;
  }

  formatMoney(money) {
    return `${parseFloat(money.amount).toFixed(2)} ${money.currencyCode}`;
  }

  formatTransactions(paymentTransactions = []) {
    return paymentTransactions.map((value) => {
      const ref = { ...value, };
      ref.paymentAmount = value.paymentAmount
        ? this.formatMoney(value.paymentAmount)
        : '';
      return ref;
    });
  }

  renderBillDetail = (bill) => {
    const billItems = VerticalLabelList.toList({
      'Customer Name': bill.clientData.customerName,
      'External Account Id': bill.externalAccountId,
      'External Bill Id': bill.externalBillId,
      'Bulk Id': bill.bulkId,
      Address: bill.clientData.address1,
      'Due Date': moment(bill.dueDate).utc().format('MM/DD/YYYY HH:MM:SS'),
      'Original Bill Balance': this.formatMoney(bill.originalBillBalance),
      'Bill Balance': this.formatMoney(bill.billBalance),
      Paid: bill.paid,
      Payable: !bill.notPayable,
      ...(bill.notPayable
        ? { 'Not Payable Reason': bill.notPayableReason, }
        : {}),
      'Client Reconciled Timestamp': bill.clientReconciledTimestamp,
      'Account Id': bill.accountId,
      Id: bill.id,
    });

    const { paymentTransactions = [], } = bill;
    const paymentExclusions = [ 'clientSnapshotData', ];
    const paymentTransactionsJson = ObjectUtils.formatStringAsJSONArray(paymentTransactions);
    const transactionModel = Grid.toModelFromList(paymentTransactionsJson, {
      headerFormatter: (value) => _.startCase(value.header),
      filter: (value) => !paymentExclusions.includes(value),
    });

    const { clientData = {}, } = bill;
    const clientDataItems = VerticalLabelList.toList(clientData);

    return (
      <>
        <FieldSet title='Water Bill'>
          <VerticalLabelList items={billItems} />
        </FieldSet>
        <FieldSet title='Payment Transactions'>
          <Grid
            headers={transactionModel.headers}
            rows={transactionModel.format(
              this.formatTransactions(paymentTransactionsJson)
            )}
          />
        </FieldSet>
        <FieldSet title='Client Data'>
          <VerticalLabelList items={clientDataItems} />
        </FieldSet>
      </>
    );
  };

  render() {
    const { isOpen, } = this.state;
    const { hideModal, bill, } = this.props;

    if (!bill) {
      return null;
    }

    return (
      <Modal show={isOpen} onHide={hideModal} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>
            Bill Id:&nbsp;
            {bill.id}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderBillDetail(bill)}</Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}

DetailedWaterBill.defaultProps = {
  bill: null,
};

DetailedWaterBill.propTypes = {
  bill: PropTypes.instanceOf(Object),
  isOpen: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default DetailedWaterBill;
